import WorkoutForm from "../components/workout/WorkoutForm";

const FormPage = ({ generationError, ...otherProps }) => {
  return (
    <div>
      {generationError && (
        <div className="mb-4 p-4 bg-red-100 text-red-700 border border-red-300 rounded">
          {generationError}
        </div>
      )}
      <WorkoutForm {...otherProps} />
    </div>
  );
};

export default FormPage;


